import { validDni } from "../account/ProfileFields";

const FIELDS = [
  ["name", "Nombre y apellidos", "text", "name", true],
  ["email", "Email", "email", "email", true],
  ["phone", "Teléfono", "tel", "tel", true],
  ["dni", "DNI / NIE", "text", "off", true],
  ["business", "Empresa (opcional)", "text", "organization", false],
  ["line1", "Dirección", "text", "address-line1", true],
  ["line2", "Piso, puerta… (opcional)", "text", "address-line2", false],
  ["postal_code", "Código postal", "text", "postal-code", true],
  ["city", "Ciudad", "text", "address-level2", true],
  ["state", "Provincia", "text", "address-level1", true],
];
const WIDE = new Set(["name", "email", "line1", "line2"]);

export const validate = (c) => {
  const e = {};
  FIELDS.forEach(([k, label, , , req]) => { if (req && !(c[k] || "").trim()) e[k] = `${label.split(" (")[0]} obligatorio`; });
  if (c.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c.email)) e.email = "Email no válido";
  if (c.phone && (c.phone.replace(/\D/g, "").length < 9)) e.phone = "Teléfono no válido";
  if (c.postal_code && !/^\d{5}$/.test(c.postal_code.trim())) e.postal_code = "5 cifras";
  if (c.dni && !validDni(c.dni)) e.dni = "DNI/NIE no válido (revisa la letra)";
  return e;
};

export const CheckoutForm = ({ value, onChange, errors }) => (
  <fieldset data-testid="checkout-form" className="grid grid-cols-2 gap-3">
    <legend className="font-serif-d font-black text-2xl mb-4">Datos de envío</legend>
    {FIELDS.map(([k, label, type, ac]) => (
      <label key={k} className={WIDE.has(k) ? "col-span-2" : "col-span-2 sm:col-span-1"}>
        <span className="text-xs text-[#C9D6C2]">{label}</span>
        <input data-testid={`checkout-${k}`} type={type} autoComplete={ac} value={value[k] || ""} inputMode={k === "postal_code" ? "numeric" : undefined}
          onChange={(e) => onChange({ ...value, [k]: e.target.value })} aria-invalid={!!errors[k]}
          className={`mt-1 w-full h-12 rounded-[8px] bg-[#143823] border px-3 text-[#F6EEDC] outline-none focus:border-[#F2B441] ${errors[k] ? "border-[#E5765B]" : "border-[#F6EEDC]/25"}`} />
        {errors[k] && <span data-testid={`checkout-${k}-error`} className="text-xs text-[#F4A58F]">{errors[k]}</span>}
      </label>
    ))}
    <p className="col-span-2 text-xs text-[#C9D6C2]">Enviamos solo a España.</p>
  </fieldset>
);
